/* Shared product visual discovery. Native Shopify and Recharge own purchase state. */
(()=>{
 function enhance(){
  if(!document.body.classList.contains('p2-product-page'))return;
  const config=JSON.parse(document.getElementById('P2ProductConfig').textContent);
  const main=document.querySelector('[id^="MainProduct-"]'),template=document.getElementById('P2VoyageStage');
  if(!main||!template)return;
  main.classList.add('p2-voyage-product');
  const media=main.querySelector('.product__media-wrapper'),info=main.querySelector('product-info'),css=document.querySelector('link[href*="phntm-voyage.css"]');
  if(!media||!info||!css)return;
  const asset=file=>new URL(file,css.href).href;
  if(!media.querySelector('.p2-voyage-stage')){
   const gallery=media.querySelector('media-gallery');
   if(gallery){gallery.classList.add('p2-voyage-native-gallery');gallery.hidden=true;gallery.inert=true}
   media.prepend(template.content.cloneNode(true));
  }
  const tabs=[...media.querySelectorAll('[role=tab]')];
  if(tabs.length&&!media.dataset.voyageTabsReady){
   media.dataset.voyageTabsReady='true';
   const select=(tab,focus=false)=>{
    for(const button of tabs){const selected=button===tab;button.setAttribute('aria-selected',String(selected));button.tabIndex=selected?0:-1;document.getElementById(button.getAttribute('aria-controls')).hidden=!selected}
    if(focus)tab.focus({preventScroll:true});
    // Scroll only the thumbnail rail, never the whole product page.
    const rail=tab.parentElement;if(rail.scrollWidth>rail.clientWidth)rail.scrollLeft=tab.offsetLeft-rail.offsetLeft-(rail.clientWidth-tab.offsetWidth)/2;
   };
   for(const [index,tab]of tabs.entries()){
    tab.addEventListener('click',()=>select(tab));
    tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(tabs[next],true)});
   }
   main.addEventListener('change',event=>{if(event.target.closest('.p2-voyage-flavors'))select(tabs[0])},true);
  }
  const h1=info.querySelector('h1');
  if(h1&&!h1.querySelector('.p2-voyage-name')){
   const title=h1.textContent.trim(),name=document.createElement('span'),kind=document.createElement('span');name.className='p2-voyage-name';kind.className='p2-voyage-kind';name.textContent=config.name;kind.textContent=config.kind;h1.replaceChildren(name,document.createTextNode(' '),kind);
  }
  if(!info.querySelector('.p2-voyage-intro')){
   const intro=document.getElementById('P2VoyageIntro');if(intro)info.querySelector('.product__title')?.after(intro.content.cloneNode(true));
  }
  const rating=info.querySelector('.loox-rating')?.closest('a');if(rating&&!rating.getAttribute('href'))rating.href='#voyage-reviews';
  if(config.key==='odyssey'&&!info.querySelector('.p2-rating-scope')){const scope=document.createElement('span');scope.className='p2-rating-scope';scope.textContent='Across PHNTM';info.querySelector('.loox-rating')?.after(scope)}
  const fieldsets=[...info.querySelectorAll('variant-radios fieldset')];
  fieldsets.forEach((field,i)=>{field.classList.add(i===0?'p2-voyage-flavors':'p2-voyage-bundles')});
  for(const label of info.querySelectorAll('.p2-voyage-bundles label')){
   if(label.querySelector('.p2-voyage-bundle-name'))continue;
   const name=document.createElement('span');name.className='p2-voyage-bundle-name';
   for(const node of [...label.childNodes])if(node.nodeType===3&&node.textContent.trim())name.append(node);
   label.prepend(name);
  }
  for(const input of fieldsets[0]?.querySelectorAll('input')||[]){const label=document.getElementById(input.id)?.nextElementSibling;if(label?.tagName==='LABEL')label.dataset.flavor=input.value}
  const plans=info.querySelector('.recharge-subscription-widget');
  if(plans&&!info.querySelector('.p2-voyage-plan-note')){const note=document.getElementById('P2VoyagePlanNote');if(note)plans.after(note.content.cloneNode(true))}
  const holder=document.querySelector('[data-voyage-details]');
  if(holder){
   for(const accordion of info.querySelectorAll('.product__accordion')){
    const heading=accordion.querySelector('.accordion__title')?.textContent.trim(),content=accordion.querySelector('.accordion__content');
    if(content&&heading?.startsWith('About')){accordion.querySelector('.accordion__title').textContent='About '+config.name;const p=document.createElement('p');p.textContent=config.detail;content.replaceChildren(p)}
    if(content&&heading==='Lab Tests'){
     const first=content.querySelector('p');if(first)first.textContent='Independent batch testing. See the current Certificates of Analysis for product-specific results.';
    }
    if(content&&heading==='Shipping & Returns'){
     const p=document.createElement('p');p.textContent='Find current shipping availability, delivery information and return terms in our policies.';
     const links=document.createElement('p');for(const [label,url]of [['Shipping details','/pages/shipping-returns'],['Returns & refunds','/pages/returns-refunds']]){const a=document.createElement('a');a.textContent=label;a.href=url;links.append(a,document.createTextNode('  '))}content.replaceChildren(p,links);
    }
    if(content&&heading==='Suggested Use'){
     const p=document.createElement('p');p.textContent='For adults 21+ only. Follow the directions and warnings on your package. Read the label before use.';content.replaceChildren(p);
    }
    holder.append(accordion);
   }
  }
  // The actual media gallery, modal buttons and all product/app forms are retained.
  if(!main.dataset.voyageReady){
   main.dataset.voyageReady='true';
   const variants=JSON.parse(main.querySelector('variant-radios script[type="application/json"]')?.textContent||'[]');
   const update=()=>{
    const options=fieldsets.map(f=>f.querySelector('input:checked')?.value),variant=variants.find(v=>v.options.every((o,i)=>o===options[i]));
    const img=media.querySelector('.p2-voyage-stage__pack'),caption=media.querySelector('[data-voyage-flavor]');
    if(!variant)return;
    if(media.dataset.voyageFlavor&&media.dataset.voyageFlavor!==variant.option1)tabs[0]?.click();
    // The flavor-party montage is existing PHNTM package artwork, not a new label.
    const party=/Flavor Bundle/i.test(variant.option1);
    const src=config.key==='odyssey'?asset(config.pack):party?asset('p2-'+config.key+'-bundle.png'):new URL(variant.featured_image?.src||asset(config.pack),location.href).href;
    if(img.src!==src)img.src=src;
    img.alt=variant.title+' — PHNTM '+config.name+' packaging';
    const captionText=variant.option1+' · '+variant.option2;if(caption.textContent!==captionText)caption.textContent=captionText;
    media.dataset.voyageFlavor=variant.option1;
    if(config.key==='odyssey'&&config.packMap){const holder=media.querySelector('.p2-odyssey-live-packs');if(holder.dataset.selection!==variant.option1){const flavors=variant.option1.split('/').map(s=>s.trim());holder.replaceChildren(...['voyage','daily','sleep'].map((key,i)=>{const pack=document.createElement('img');pack.src=config.packMap[key][flavors[i]];pack.alt=({voyage:'Voyage',daily:'Daily Cruiser',sleep:'Deep Sleep'})[key]+' '+flavors[i]+' packaging';pack.width=400;pack.height=500;return pack}));holder.dataset.selection=variant.option1}}

   };
   main.addEventListener('change',()=>requestAnimationFrame(update));
   document.addEventListener('phntm:preview-variant',update);
   update();
  }
  for(const video of document.querySelectorAll('loox-video-slider-widget')){
   video.removeAttribute('auto-play');video.setAttribute('text-color','#ffffff');
   video.closest('.shopify-section')?.classList.add('p2-voyage-videos');
  }
  document.getElementById('looxReviews')?.closest('.shopify-section')?.classList.add('p2-voyage-reviews');
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
 window.addEventListener('w3-scripts-loaded',enhance);document.addEventListener('shopify:section:load',enhance);
})();
